<script setup>
import ClaimInfoComponent from "@/Components/ClaimInfo/ClaimInfoComponent.vue";
import InsuredInfoComponent from "@/Components/Claims/InsuredInfoComponent.vue";
import InvoicesComponent from "@/Components/Invoices/InvoicesComponent.vue";
import AdminsComponent from "@/Components/Admins/AdminsComponent.vue";
import ListComponent from "@/Components/Tasks/ListComponent.vue";
import ClientTimelineComponent from "@/Components/Timeline/ClientTimelineComponent.vue";
import {useRoute} from "vue-router";

const route = useRoute();
</script>

<template>
  <v-container fluid style="height: auto">
    <v-row>
      <v-col cols="6">
        <v-row>
          <v-col cols="12">
            <ClaimInfoComponent :contextIdA="route.params.claimId"/>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <InvoicesComponent :contextIdA="route.params.claimId"/>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="6">
        <v-row>
          <v-col cols="6">
            <InsuredInfoComponent :contextIdA="route.params.claimId"/>
          </v-col>
          <v-col cols="6">
            <AdminsComponent :contextIdA="route.params.claimId"/>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <ListComponent :claimId="route.params.claimId"/>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <ClientTimelineComponent :contextIdA="route.params.claimId"/>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<style scoped>

</style>